export default "__VITE_ASSET__B48wKAEj__"